(function () {
  if (window.__pioletComboBuybox) return;
  window.__pioletComboBuybox = true;

  var GUARD_MS = 1500;
  var guardUntil = 0;
  var postedAt = 0;
  var cleanFetch = null;
  var savedFetch = window.fetch;
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  var xhrSet = XMLHttpRequest.prototype.setRequestHeader;

  function money(cents) {
    var pesos = Math.round(Number(cents) / 100);
    var body = String(pesos).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return "$" + body;
  }

  function paint(root) {
    var selected = root.querySelector('input[name="piolet_combo"]:checked');
    if (!selected) return;
    var cents = Number(selected.getAttribute("data-cents")) || 0;
    var warranty = root.querySelector("[data-warranty]");
    if (warranty && warranty.checked) {
      cents += Number(root.getAttribute("data-warranty-cents")) || 0;
    }
    var text = money(cents);
    root.querySelectorAll("[data-amount]").forEach(function (node) {
      node.textContent = text;
    });
    var main = document.querySelector("[data-pio-price]");
    if (main) {
      var now = main.querySelector(".pio-price__now");
      if (now) now.textContent = text;
      var compare = selected.getAttribute("data-compare") === "1" && !(warranty && warranty.checked);
      main.querySelectorAll(".pio-price__was, .pio-price__save").forEach(function (node) {
        node.hidden = !compare;
      });
      var pesos = Math.round(cents / 100);
      var months = pesos >= 40000 ? 12 : 9;
      var monthly = money(Math.round(pesos / months) * 100);
      var pattern = root.getAttribute("data-msi-pattern") || "@@M@@ MSI de @@A@@";
      var msi = pattern.replace("@@M@@", String(months)).replace("@@A@@", monthly);
      var msiNode = main.querySelector(".pio-price__msi strong");
      if (msiNode) msiNode.textContent = msi;
    }
    document.querySelectorAll(".piolet-finance__kicker").forEach(function (node) {
      var pesos = Math.round(cents / 100);
      var months = pesos >= 40000 ? 12 : 9;
      var monthly = money(Math.round(pesos / months) * 100);
      var pattern = root.getAttribute("data-msi-pattern") || "@@M@@ MSI de @@A@@";
      node.textContent = pattern.replace("@@M@@", String(months)).replace("@@A@@", monthly);
    });
  }

  function bind(root) {
    if (root.dataset.bound === "1") return;
    root.dataset.bound = "1";
    root.addEventListener("change", function () {
      paint(root);
    });
    paint(root);
    bindSticky(root);
  }

  function bindSticky(root) {
    var bar = document.querySelector("[data-piolet-sticky]");
    if (!bar || bar.dataset.bound === "1") return;
    bar.dataset.bound = "1";
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    var jump = bar.querySelector("[data-sticky-jump]");
    if (jump) {
      jump.addEventListener("click", function () {
        var top = root.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
      });
    }
    var shown = false;
    function place() {
      var past = root.getBoundingClientRect().bottom < 0;
      if (past === shown) return;
      shown = past;
      if (past) {
        bar.hidden = false;
        bar.classList.add("is-open");
        requestAnimationFrame(function () {
          if (shown) bar.classList.add("is-visible");
        });
        return;
      }
      bar.classList.remove("is-visible");
      var finishHide = function () {
        if (shown) return;
        bar.classList.remove("is-open");
        bar.hidden = true;
      };
      bar.addEventListener("transitionend", finishHide, { once: true });
      window.setTimeout(finishHide, 180);
    }
    requestAnimationFrame(place);
    window.addEventListener("scroll", place, { passive: true });
    window.addEventListener("resize", place);
  }

  function boot() {
    document.querySelectorAll("[data-piolet-combo]").forEach(bind);
  }

  function arm() {
    guardUntil = Date.now() + GUARD_MS;
  }

  function headerValue(headers, name) {
    if (!headers) return "";
    var want = name.toLowerCase();
    if (typeof headers.get === "function") {
      var found = headers.get(name);
      return found == null ? "" : String(found);
    }
    if (Array.isArray(headers)) {
      for (var i = 0; i < headers.length; i++) {
        if (String(headers[i][0]).toLowerCase() === want) return String(headers[i][1]);
      }
      return "";
    }
    for (var key in headers) {
      if (Object.prototype.hasOwnProperty.call(headers, key) && String(key).toLowerCase() === want) {
        return String(headers[key]);
      }
    }
    return "";
  }

  function requestUrl(input) {
    if (typeof input === "string") return input;
    if (input && typeof input.url === "string") return input.url;
    return "";
  }

  function isCartAdd(url) {
    return String(url || "").indexOf("/cart/add") !== -1;
  }

  function isOurs(headers) {
    return headerValue(headers, "X-Piolet-Combo") === "1";
  }

  function choiceFor(root) {
    var selected = root.querySelector('input[name="piolet_combo"]:checked');
    if (!selected) return null;
    var warranty = root.querySelector("[data-warranty]");
    var handle = selected.value;
    if (handle === "solo" && !(warranty && warranty.checked)) return null;
    return { selected: selected, warranty: warranty, handle: handle };
  }

  function comboSelected() {
    var root = document.querySelector("[data-piolet-combo]");
    return !!(root && choiceFor(root));
  }

  function shouldCancel(url, headers) {
    if (!isCartAdd(url) || isOurs(headers)) return false;
    if (Date.now() < guardUntil) return true;
    return comboSelected();
  }

  function cancelledAdd() {
    return new Response(JSON.stringify({ status: 422, message: "" }), {
      status: 422,
      headers: { "Content-Type": "application/json" },
    });
  }

  // El script corre antes que theme.js (defer). Este envoltorio ya esta puesto
  // cuando el tema llama fetch, aunque su listener haya corrido primero.
  if (typeof savedFetch === "function") {
    window.fetch = function (input, init) {
      var headers = init && init.headers;
      if (!headers && input && typeof input !== "string") headers = input.headers;
      if (shouldCancel(requestUrl(input), headers)) return Promise.resolve(cancelledAdd());
      return savedFetch.apply(this, arguments);
    };
  }

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__pioUrl = url || "";
    this.__pioOurs = false;
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.setRequestHeader = function (name, value) {
    if (String(name).toLowerCase() === "x-piolet-combo" && String(value) === "1") this.__pioOurs = true;
    return xhrSet.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (!this.__pioOurs && shouldCancel(this.__pioUrl, null)) {
      var self = this;
      window.setTimeout(function () {
        try {
          Object.defineProperty(self, "readyState", { configurable: true, get: function () { return 4; } });
          Object.defineProperty(self, "status", { configurable: true, get: function () { return 422; } });
          Object.defineProperty(self, "responseText", { configurable: true, get: function () { return "{\"status\":422}"; } });
        } catch (error) {}
        if (typeof self.onreadystatechange === "function") self.onreadystatechange();
        try { self.dispatchEvent(new Event("loadend")); } catch (error) {}
      }, 0);
      return;
    }
    return xhrSend.apply(this, arguments);
  };

  // Kaching envuelve window.fetch y, en el click del boton (captura en window,
  // antes que document), puede reescribir el body de cart/add. Un iframe
  // same-origin conserva el fetch del navegador. Si no se puede, la query
  // kaching_bundles=true es la que ese interceptor deja pasar sin mezclar.
  function cartFetch(url, options) {
    if (!cleanFetch) {
      try {
        var frame = document.createElement("iframe");
        frame.hidden = true;
        frame.setAttribute("aria-hidden", "true");
        (document.body || document.documentElement).appendChild(frame);
        var child = frame.contentWindow;
        if (child && child.fetch) cleanFetch = child.fetch.bind(child);
      } catch (error) {
        cleanFetch = null;
      }
    }
    if (cleanFetch && cleanFetch !== window.fetch) return cleanFetch(url, options);
    var bypass = url.indexOf("kaching_bundles=") === -1
      ? url + (url.indexOf("?") === -1 ? "?" : "&") + "kaching_bundles=true"
      : url;
    return window.fetch(bypass, options);
  }

  function isSubmitControl(node, form) {
    if (!node || !node.closest) return false;
    var control = node.closest("button, input");
    if (!control || !form.contains(control)) return false;
    var type = (control.getAttribute("type") || "").toLowerCase();
    if (control.tagName === "BUTTON") return type === "" || type === "submit";
    return type === "submit";
  }

  function productFormFrom(event) {
    if (event.type === "submit") {
      var form = event.target;
      if (!form || !form.classList || !form.classList.contains("product-single__form")) return null;
      return form;
    }
    if (event.type === "keydown") {
      var keyNode = event.target;
      if (!keyNode || !keyNode.closest) return null;
      return keyNode.closest("form.product-single__form");
    }
    var node = event.target;
    if (!node || !node.closest) return null;
    if (node.closest("[data-sticky-jump]")) return null;
    var host = node.closest("form.product-single__form");
    if (host && isSubmitControl(node, host)) return host;
    var add = node.closest("[data-add-to-cart], [data-add-to-cart-drawer]");
    if (!add || add.closest("[data-sticky-jump]")) return null;
    return (host && host.contains(add) ? host : null) || document.querySelector("form.product-single__form");
  }

  function postCombo(root, choice, button) {
    arm();
    var now = Date.now();
    if (now - postedAt < GUARD_MS) return;
    postedAt = now;

    var items = [];
    try {
      items = JSON.parse(choice.selected.getAttribute("data-items") || "[]");
    } catch (error) {
      items = [];
    }
    var payload = items.map(function (item) {
      var row = { id: item.id, quantity: item.qty || 1 };
      if (choice.handle !== "solo") row.properties = { _piolet_combo: choice.handle };
      return row;
    });
    if (choice.warranty && choice.warranty.checked) {
      payload.push({
        id: Number(root.getAttribute("data-warranty-variant")),
        quantity: 1,
      });
    }

    if (button) button.classList.add("btn--loading");
    var errorNode = root.querySelector("[data-combo-error]");
    if (errorNode) errorNode.hidden = true;

    // Un solo POST. Shopify emite product_added_to_cart por cada linea
    // de esta respuesta. Los pixeles de canal escuchan ese evento.
    // Este archivo no dispara un evento de marketing aparte.
    cartFetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "X-Piolet-Combo": "1",
      },
      body: JSON.stringify({ items: payload }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        var first = data && data.items ? data.items[0] : data;
        document.dispatchEvent(new CustomEvent("ajaxProduct:added", {
          detail: { product: first, addToCartBtn: button },
          bubbles: true,
        }));
        document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
      })
      .catch(function () {
        postedAt = 0;
        if (errorNode) errorNode.hidden = false;
      })
      .finally(function () {
        if (button) button.classList.remove("btn--loading");
      });
  }

  function intercept(event) {
    if (event.type === "keydown" && event.key !== "Enter") return;
    if (event.type === "keydown" && event.target && event.target.tagName === "TEXTAREA") return;
    var form = productFormFrom(event);
    if (!form) return;
    var root = document.querySelector("[data-piolet-combo]");
    if (!root) return;
    var choice = choiceFor(root);
    if (!choice) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var button = null;
    if (event.type === "submit") button = event.submitter || form.querySelector("[data-add-to-cart]");
    else if (event.target && event.target.closest) button = event.target.closest("button, input");
    if (!button || button.closest("[data-sticky-jump]")) button = form.querySelector("[data-add-to-cart]");
    postCombo(root, choice, button);
  }

  function bindForms() {
    document.querySelectorAll("form.product-single__form").forEach(function (form) {
      if (form.getAttribute("data-piolet-combo-bound") === "1") return;
      form.setAttribute("data-piolet-combo-bound", "1");
      form.addEventListener("click", intercept, true);
      form.addEventListener("submit", intercept, true);
      form.addEventListener("keydown", intercept, true);
    });
  }

  window.addEventListener("click", intercept, true);
  window.addEventListener("submit", intercept, true);
  window.addEventListener("keydown", intercept, true);
  document.addEventListener("click", intercept, true);
  document.addEventListener("submit", intercept, true);
  document.addEventListener("keydown", intercept, true);
  bindForms();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot();
      bindForms();
    });
  } else {
    boot();
  }
  window.setTimeout(bindForms, 500);
  window.setTimeout(bindForms, 3200);
  if (window.MutationObserver && document.documentElement) {
    var formsObserver = new MutationObserver(function () {
      boot();
      bindForms();
    });
    formsObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
